import { createSelector, createStructuredSelector } from 'reselect';
import { skusSelector } from 'src/selectors/sku';
import { userSelector, userPlanIdSelector } from 'src/selectors/user';
import { cartSelector } from 'src/selectors/cart';
import { adjustProductInfo, trimSeoName } from './utils';
import { PAGE_NAME } from './constants';

const seoNameSelector = (_, ownProps) => {
  const {
    match: {
      params: { id },
    },
  } = ownProps;
  return id;
};

const skuSelector = createSelector(skusSelector, seoNameSelector, (skus, seoName) => {
  if (seoName) {
    const newSeoName = trimSeoName({ seoName });
    return Object.values(skus).find((s) => s.seoName === newSeoName);
  }
  return null;
});

const productSelector = createSelector(
  skuSelector,
  cartSelector,
  userSelector,
  (state) => {
    return {
      selectedPlanId: state.getIn(['entities', 'cart', 'plan', 'id'], null),
      reviews: state.getIn(['entities', 'reviews'], null).toJS(),
      plan: state.getIn(['pages', PAGE_NAME, 'plan'], null),
      plansInfo: state.getIn(['pages', PAGE_NAME, 'plansInfo'], null).toJS(),
    };
  },
  (sku, cart, user, extra) => {
    const cartHasPlan = cart.get('plan');
    const userHasSubscription = user && user.getIn(['account', 'hasSubscription']);
    const showMemberPrice = !!(cartHasPlan || userHasSubscription);
    const showUpsell = !userHasSubscription && (sku && sku.includedInUpsellPlan);
    return adjustProductInfo({ sku, showMemberPrice, showUpsell, ...extra });
  },
);

export default createStructuredSelector({
  seoName: seoNameSelector,
  sku: skuSelector,
  product: productSelector,
  userPlanId: userPlanIdSelector,
});
